import API from "../api";
import {pipe} from "fp-ts/function";
import {from, Observable} from "rxjs";
import * as OBS from "fp-ts-rxjs/Observable";
import {ISubscriptionData} from "../model/subscription.model";
import {ITotalSubscriptions} from "../model/export.model";
import {IEnrollment} from "../model/enrollment.model";

const BASE_PATH = 'export'

export const exportCompetitorsBySchoolAndEvent = (eventId: number | string, schoolId: number): Observable<ReadonlyArray<ISubscriptionData>> => {
    return pipe(
        from(API.get(BASE_PATH + "/competitorsBySchoolAndEvent", {
            params: {
                eventId,
                schoolId
            }
        })),
        OBS.map((res): ReadonlyArray<ISubscriptionData> => res.data)
    )
}

export const exportCompetitorsByEvent = (eventId: number | string): Observable<ITotalSubscriptions> => {
    return pipe(
        from(API.get(BASE_PATH + "/competitorsByEvent", {
            params: {
                eventId
            }
        })),
        OBS.map((res): ITotalSubscriptions => res.data)
    )
}

export const exportEnrollmentsBySchoolAndEnrollment = (schoolId: number, enrollmentId: number): Observable<ReadonlyArray<IEnrollment>> => {
    return pipe(
        from(API.get(BASE_PATH + "/enrollmentsBySchool", {
            params: {
                schoolId,
                enrollmentId
            }
        })),
        OBS.map((res): ReadonlyArray<IEnrollment> => res.data)
    )
}

export const exportMusicByEventId = (
    eventId: number
): Observable<Blob> => {
    return from(
        API.get(BASE_PATH + "/music", {
            params: { eventId },
            responseType: "blob"
        })
    ).pipe(
        OBS.map((res) => res.data as Blob)
    );
};
